import { Skeleton } from 'antd';
import React from 'react';

const HielocoSkeleton = ({ cols = 1 }) => {
  return Array(cols)
    .fill()
    .map((col, index) => (
      <div key={col} className="w-full" key={index}>
        <Skeleton.Input
          active
          className="w-full h-full"
          style={{ minHeight: 88 }}
        />
      </div>
    ));
};

export default HielocoSkeleton;
